import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
    reachPlansFailure,
    reachPlansSuccess,
    coveragePlansFailure,
    coveragePlansSuccess,
    getInTouchFailure,
    getInTouchSuccess,
    earthlinkReachPlanSuccess,
    earthlinkReachPlanFailure,
    checkCoverage,
    checkCoverageSuccess,
    checkCoverageFailure,
    inviteRefereeCouponSuccess,
    inviteRefereeCouponFailure
} from './actions';
import { REACT_PLANS, COVERAGE_PLANS, GET_IN_TOUCH, EARTHLINK_REACH_PLAN, CHECK_COVERAGE, INVITE_REFEREE_COUPON } from './actionTypes';
import apiJunction from '../../utils/api';
import { version } from '../../config';
import ApiEndPoints from '../../utils/ApiEndPoints';

export interface ResponseGenerator {
    config?: any;
    data?: any;
    headers?: any;
    request?: any;
    status?: number;
    statusText?: string;
}

function* reachPlans() {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url: `${ApiEndPoints?.reachPlans}`,
        });
        yield put(
            reachPlansSuccess({
                plans: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            reachPlansFailure({
                error: e.message,
            }),
        );
    }
}

function* coveragePlans(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            // url: `/provsvc/${version}/zip/USA/${action.payload.zipcode}`,
            url: `${ApiEndPoints.coveragePlans}/${action.payload.zipcode}`,
        });
        yield put(
            coveragePlansSuccess({
                coveragePlans: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            coveragePlansFailure({
                coverageError: { data: e.response && e.response.data, status: e.response && e.response.status },
            }),
        );
    }
}

function* getInTouch(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'post',
            url: `${ApiEndPoints.getInTouch}`,
            body: action.payload.data,
        });
        yield put(
            getInTouchSuccess({
                getInTouch: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            getInTouchFailure({
                getInTouchError: e.message,
            }),
        );
    }
}
function* earthlinkReachPlan(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url: `/catalogsvc/${version}/reachplans/${action.payload.plan}`,
        });
        yield put(
            earthlinkReachPlanSuccess({
                plansEarthlink: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            earthlinkReachPlanFailure({
                errorPlansEarthlink: e.message,
            }),
        );
    }
}
function* checkCoverageSaga(action: any) {
    try {
        checkCoverage({});
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'post',
            url: `/provsvc/${version}/address/network/coverage`,
            body: action.payload,
        });
        yield put(
            checkCoverageSuccess({
                coverageStatus: response.data.data,
            }),
        );
    } catch (e: any) {
        yield put(
            checkCoverageFailure({
                errorCoverageStatus: e.response?.data ?? e,
            }),
        );
    }
}

function* inviteRefereeCoupon(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'post',
            url: `/catalogsvc/${version}/coupon/invite/referee`,
            body: action.payload,
        });
        yield put(
            inviteRefereeCouponSuccess({
                inviteRefereeStatus: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            inviteRefereeCouponFailure({
                errorInviteRefereeStatus: e.message,
            }),
        );
    }
}

function* homeSaga() {
    yield all([
        takeLatest(REACT_PLANS, reachPlans),
        takeLatest(COVERAGE_PLANS, coveragePlans),
        takeLatest(GET_IN_TOUCH, getInTouch),
        takeLatest(EARTHLINK_REACH_PLAN, earthlinkReachPlan),
        takeLatest(CHECK_COVERAGE, checkCoverageSaga),
        takeLatest(INVITE_REFEREE_COUPON, inviteRefereeCoupon),
    ]);
}

export default homeSaga;
